import React from 'react';
import { ICarouselBox, inc, renderSeparateLine, Styles } from './CarouselWrapper';
import { Carousel } from './Carousel';
import { PrivateMeetingSessionDetailsResponseType } from '../../../../lib/api';
import { CardComponent } from './Card';

interface IDefaultCarouselProps extends ICarouselBox {
  shouldRenderSeparateLine: boolean;
}


const DefaultCarousel = ({
  meetings,
  event,
  eventToken,
  transformedTimeZone,
  shouldRenderSeparateLine,
  onSubscriptionChange
}: IDefaultCarouselProps): JSX.Element => {
  return (
    <>

      <div className={`${Styles.blockRow} px-8 -mt-4`}>
        <Carousel>
          {meetings.map((meeting: PrivateMeetingSessionDetailsResponseType, i: number) => (
            <CardComponent
              index={i + inc}
              meeting={meeting}
              event={event}
              key={meeting.meetingId}
              eventToken={eventToken}
              transformedTimeZone={transformedTimeZone}
              onSubscriptionChange={onSubscriptionChange}
            />
          ))}
        </Carousel>
      </div>
      {renderSeparateLine(Boolean(shouldRenderSeparateLine && meetings.length))}
    </>
  );
};

export default DefaultCarousel;
